export const FETCH_FAV_LINES = 'fetchFavLines';
export const FETCH_FAV_LINES_SUCCESS = 'fetchFavLinesSuccess';
